@if (show) {
    <div id="loading" class="loading-overlay">
        <div class="loading-box">
            @if (!text) {
                <span>Getting things ready for you...</span>
            }
            @if (text) {
                <span>{{ text }}</span>
            }
            <div class="spinner"></div>
        </div>
    </div>
}
